import script from "./CotizacionesList.vue?vue&type=script&setup=true&lang=js"
export * from "./CotizacionesList.vue?vue&type=script&setup=true&lang=js"

import "./CotizacionesList.vue?vue&type=style&index=0&id=d065ca6c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d065ca6c"]])

export default __exports__